import Icon from 'ol/style/Icon.js';
import { dataIconScale, type DataIcon } from '../shared/data-icon.js';

export function dataIconStyle(icon: DataIcon): Icon {
  return new Icon({
    src: icon.src, anchor: icon.anchor, scale: dataIconScale(icon),
    rotation: icon.heading * Math.PI / 180, color: icon.color,
    opacity: icon.opacity, declutterMode: 'none',
  });
}

export async function dataIconCanvas(icon: DataIcon): Promise<HTMLCanvasElement> {
  const style = dataIconStyle(icon);
  style.load();
  await style.ready();
  const image = style.getImage(1);
  const scale = dataIconScale(icon);
  const width = icon.width * scale, height = icon.height * scale;
  const radius = Math.ceil(Math.hypot(Math.max(icon.anchor[0], 1 - icon.anchor[0]) * width, Math.max(icon.anchor[1], 1 - icon.anchor[1]) * height));
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = Math.max(1, radius * 2);
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Icon rendering requires a 2D canvas');
  context.translate(radius, radius);
  context.rotate(icon.heading * Math.PI / 180);
  context.globalAlpha = icon.opacity;
  context.drawImage(image, -icon.anchor[0] * width, -icon.anchor[1] * height, width, height);
  return canvas;
}
